import { Button, ButtonShortcut } from "@/components/sidebar/Button";
import { ComboButton } from "@/components/sidebar/ComboButton";
import * as SidebarLayoutComponents from "@/components/sidebar/SidebarLayout";
import { ToggleButton } from "@/components/sidebar/ToggleButton";

export const Sidebar = {
  ...SidebarLayoutComponents,
  Button,
  ButtonShortcut,
  ComboButton,
  ToggleButton,
};
